export function mapToEntries<K, V>(map: Map<K, V>): Array<[K, V]> {
  const entries: Array<[K, V]> = []

  for (const entry of map.entries()) {
    entries.push(entry)
  }

  return entries
}

export function entriesToMap<K, V>(array: Array<[K, V]>): Map<K, V> {
  const map = new Map<K, V>()

  for (const entry of array) {
    map.set(entry[0], entry[1])
  }

  return map
}
